export enum ResultSectionEnum {
  MAIN = "MAIN",
  ENVIRONMENTAL_LOCAL = "ENVIRONMENTAL_LOCAL",
  ENVIRONMENTAL = "ENVIRONMENTAL",
  ECONOMIC = "ECONOMIC",
  AGRONOMIC = "AGRONOMIC",
  IMPACT = "IMPACT",
}

export enum ResultItemEnum {
  digestate,
  waste,
  gross_revenue,
  jobs,
  households,
  bus,
  greenhouse,
  nitrogen,
  net_revenue,
  tradein_price,
  extra_revenue,
  amending_potential,
  fertilizing_potential,
  spread_area,
}

export interface ResultItemType {
  section: ResultSectionEnum;
  header?: boolean;
  icon?: string;
}

export const RESULT_ITEMS_FARMER: { [key: string]: ResultItemType } = {
  digestate: {
    section: ResultSectionEnum.MAIN,
    header: true,
    icon: "weight",
  },
  revenue: {
    section: ResultSectionEnum.MAIN,
    header: true,
    icon: "revenue",
  },
  waste: {
    section: ResultSectionEnum.MAIN,
    icon: "vegetal",
  },
  tradein_price: {
    section: ResultSectionEnum.ECONOMIC,
  },
  net_revenue: {
    section: ResultSectionEnum.ECONOMIC,
  },
  co2_production: {
    section: ResultSectionEnum.ECONOMIC,
  },
  fertilizing_potential: {
    section: ResultSectionEnum.AGRONOMIC,
  },
  co2: {
    section: ResultSectionEnum.IMPACT,
  },
  co2_eq: {
    section: ResultSectionEnum.IMPACT,
  },
  created_jobs: {
    section: ResultSectionEnum.IMPACT,
  },
};

export const RESULT_ITEMS_COLLECTIVITY: { [key: string]: ResultItemType } = {
  waste: {
    section: ResultSectionEnum.MAIN,
    header: true,
    icon: "vegetal",
  },
  digestate: {
    section: ResultSectionEnum.MAIN,
    header: true,
    icon: "weight",
  },
  fertilizing_potential: {
    section: ResultSectionEnum.ENVIRONMENTAL_LOCAL,
  },
  created_jobs: {
    section: ResultSectionEnum.ENVIRONMENTAL_LOCAL,
  },
  co2_eq: {
    section: ResultSectionEnum.ENVIRONMENTAL_LOCAL,
  },
};
